// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4acdab0c","885":"95f1708e"}[chunkId] + ".chunk.js";
};